<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 12L21.885 9.885L13.5 18.255L13.5 0L10.5 0L10.5 18.255L2.115 9.885L0 12L12 24L24 12Z" fill="#00903C" />
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
